import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { id } from 'date-fns/locale';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { PositiveNumber } from 'src/app/model/positive_number';
// there are different types of wages which is been set by different users
//def_com: default company
//spe_com : specfic company
//def_emp : default employee
//spe_emp : specific employee
@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent {
  public addForm!: FormGroup;
  public isEmployeeSetting: boolean = false;
  public wagesType!: string;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  public isEdit: boolean = false;
  public categoryArr: any[] = []
  public subCategoryArr: any[] = [];
  public categoryError!: string;
  constructor(private fb: FormBuilder, private appService: AppService, private dialogRef: MatDialogRef<AddCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, public recruiterService: RecruiterService, private commonService: CommonService,
    public dialog: MatDialog, private spinner: NgxSpinnerService
  ) { }
  ngOnInit(): void {
    this.addForm = this.fb.group({
      j_c: ["", Validators.required],
      subcategories: this.fb.array([])
    })
    if (this.dialogData && this.dialogData.isEmployeeSetting) {
      this.isEmployeeSetting = true;
      this.getCategoryList()
    }
    if (this.dialogData && this.dialogData.wages_type) {
      this.wagesType = this.dialogData.wages_type
    }
    // if the modal is opened to edit the category then set value or else add category
    if (this.dialogData.category_data) {
      this.isEdit = true;
      this.addForm.get('j_c')?.setValue(this.dialogData.category_data.j_c)
      this.setFormArray(this.dialogData.category_data.sub_category);
    }
    else {
      this.addSubcategory()
    }
  }
  getCategoryList() {
    this.recruiterService.getCategoryList({}).subscribe({
      next: (success: any) => {
        this.categoryArr = [];
        this.subCategoryArr = [];
        if (success.msg) {
          this.categoryArr = success.msg;
          if (this.dialogData?.category_data?.j_c) {
            let catItem = this.categoryArr.find((item) => item.j_c == this.dialogData?.category_data?.j_c);
            this.subCategoryArr = [];
            if (catItem) {
              this.subCategoryArr = catItem.sub_category;
            }
          }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSelectCategory(event) {
    let catItem = this.categoryArr.find((item) => item.j_c == event.value);
    this.subCategoryArr = [];
    if (catItem) {
      this.subCategoryArr = catItem.sub_category;
    }
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  get subcategories(): FormArray {
    return this.addForm.get('subcategories') as FormArray;
  }
  addSubcategory(): void {
    // if you make any changes in this function please make sure you make and check setFormArray function also
    const subcategoryForm = this.fb.group({
      j_sc: ['', Validators.required],
      wages: ['', [Validators.required, PositiveNumber]],
      id: "",
    });
    this.subcategories.push(subcategoryForm);
  }
  setFormArray(data: any[]) {
    // if you make any changes in this function please make sure you make and check setFormArray function also
    const formArray = this.subcategories;
    data.forEach(item => {
      formArray.push(this.fb.group({
        j_sc: new FormControl(item.j_sc, [Validators.required]),
        wages: new FormControl(item.wages, [Validators.required, PositiveNumber]),
        id: new FormControl(item.id),

      }));
    });
  }
  removeSubcategory(index: number): void {
    this.subcategories.removeAt(index);
  }
  hasDuplicates(arr) {
    const seen = new Set();
    for (const item of arr) {
      if (seen.has(item.j_sc)) {
        return true;
      }
      seen.add(item.j_sc);
    }
    return false;
  }
  onSubmit() {
    this.categoryError = ""
    if (this.addForm.valid == false) {
      this.addForm.markAllAsTouched();
    }
    else {
      let objReq = {}
      if (this.dialogData.type = 'specCom') {
        objReq = {
          "w_t": this.wagesType, //def_com,spe_com,def_emp,spe_emp
          "j_c": this.addForm.get('j_c')?.value,
          "em_i": this.dialogData?.em_i ? this.dialogData.em_i : "",
          "co_i": this.dialogData.co_i,
          "j_sc_arr": this.addForm.get('subcategories')?.value
        }
      } else {
         objReq = {
          "w_t": this.wagesType, //def_com,spe_com,def_emp,spe_emp
          "j_c": this.addForm.get('j_c')?.value,
          "em_i": this.dialogData?.em_i ? this.dialogData.em_i : "",
          "co_i": "",
          "j_sc_arr": this.addForm.get('subcategories')?.value
        }
      }


      if (this.hasDuplicates(this.addForm.get('subcategories')?.value)) {
        this.categoryError = "Duplicate sub category is not allowed."
        return;
      }
      this.spinner.show()
      if (this.isEdit) {
        objReq["id"] = this.dialogData.category_data.id;
        this.recruiterService.editJobCategory(objReq).subscribe({
          next: (success: any) => {
            this.spinner.hide();
            if (success.status == 200) {
              this.appService.showToastMessage('success', success.msg);
              this.dialogRef.close({ data_added: true });
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.commonService.handleError(error);
          }
        })
      }
      else {
        this.recruiterService.addJobCategory(objReq).subscribe({
          next: (success: any) => {
            this.spinner.hide();
            if (success.status == 200) {
              this.appService.showToastMessage('success', success.msg);
              this.dialogRef.close({ data_added: true });
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.commonService.handleError(error);
          }
        })
      }
    }
  }
  onCancel() {
    this.dialogRef.close();
  }
}